// Import your global components here
import Empty from "@/components/Empty.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import DebounceInput from "@/components/DebounceInput.vue";
import DatePickerStartEnd from "@/components/DatePickerStartEnd.vue";

export default {
  install(app) {
    // Register your global components here
    app.component("Empty", Empty);
    app.component("SvgIcon", SvgIcon);
    app.component("DebounceInput", DebounceInput);
    app.component("DatePickerStartEnd", DatePickerStartEnd);
  },
};
